import React, { useState, useEffect, useRef } from "react";
import useTable from "../components/useTable";
import { Mensaje, MensajeSiNo } from "../components/mensajes";
import { Dimmer } from "../components/spinner";
import axios from "axios";
import moment from "moment";
import { formatMoneda } from "../util/varios";
import { SolicitudSolvencia } from "../components/solvencia/agregar_solvencia";
import { Toasts } from "../components/toasts";

function Solvencia() {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const accopsolvencia = JSON.parse(localStorage.getItem("accopsolvencia"));

  const [mostrar, setMostrar] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [tab, setTab] = useState(1);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState();
  const [activate, setActivate] = useState(false);
  const [solvencia, setSolvencia] = useState(null);
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const imprimirPago = (item) => (event) => {
    event.preventDefault();

    var titulo =
      item.txtestatuspago === 1 ? "Certificado de Pago Electrónico" : "";
    var estatus = item.txtestatuspago === 1 ? "'-2'" : "'0'";
    var certificado = item.txtestatuspago === 1 ? "true" : "false";
    var tipo = item.txttipopago === 1 ? "Depo" : "Trans";

    window.open(
      op.reportes +
        "FACTURA=" +
        item.txtidfact +
        "&titulo=" +
        titulo +
        "&estatus=" +
        estatus +
        "&certificado=" +
        certificado +
        "&reporte=" +
        tipo,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const imprimirSolvencia = (item) => (event) => {
    event.preventDefault();

    if (accopsolvencia.substring(1, 2) !== "0") {
      window.open(
        op.reportes +
          "IDSOLVENCIA=" +
          item.txtidsolvencia +
          "&reporte=SolicitudSolvencia",
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    } else {
      setToast({
        ...toast,
        mostrar: true,
        titulo: "Notificación",
        mensaje: "No Posee los Permisos para Realizar esta Acción",
      });
    }
  };

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N°",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CONTRIBUYENTE",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA SOLICITUD",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "MONTO A PAGAR",
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "ESTATUS PAGO",
      textAlign: "center",
    },
    {
      id: "6",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "ESTATUS SOLICITUD",
      textAlign: "center",
    },
    {
      id: "7",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "",
      textAlign: "center",
    },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.txtidsolvencia.includes(target.value) ||
              x.txtnombre.toLowerCase().includes(target.value.toLowerCase()) ||
              moment(x.txtfecha)
                .format("DD-MM-YYYY")
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              (x.txtestatuspago === 1
                ? "Pagada"
                : x.txtestatuspago === 2
                ? "Verificando Pago"
                : "Por Pagar"
              )
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              (x.txtestatussolvencia === 1
                ? "Aprobada"
                : x.txtestatussolvencia === 2
                ? "Entregada"
                : x.txtestatussolvencia === 3
                ? "Rechazada"
                : "Por Aprobar"
              )
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  var estilos = {
    tab: {
      borderBottomLeftRadius: 0.25,
      borderBottomRightRadius: 0.25,
      border: "solid rgba(5, 81, 130, 1)",
      borderBottom: "none",
    },
    contenido: {
      border: "solid rgba(5, 81, 130, 1)",
    },
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "seleccionar_solvencias()";
    let orden = "txtidsolvencia desc";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
          } else {
            setRecords([]);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistro = (idsol) => {
    let campos = "*";
    let nomtab = "solvencia";
    let nomid = "idsolvencia";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idsol}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        console.log(response.data);

        if (response.status === 200) {
          if (response.data !== "") {
            setSolvencia(response.data);
            setMostrar(true);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    setActivate(true);
  };

  const cerrarModalSolvencia = (op) => {
    setMostrar(false);
    if (op === "1") {
      seleccionarRegistros();
    }
  };

  const cerrarModal = () => {
    seleccionarRegistros();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const gestionarSolicitud = (op, id) => (e) => {
    e.preventDefault();

    setOperacion(op);
    if (op === 1) {
      if (accopsolvencia.substring(1, 2) !== "0") {
        setMostrar(true);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 2) {
      if (accopsolvencia.substring(2, 3) !== "0") {
        seleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 3) {
      if (accopsolvencia.substring(3, 4) !== "0") {
        seleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 4) {
      if (accopsolvencia.substring(0, 1) !== "0") {
        seleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    }
  };

  useEffect(() => {
    seleccionarRegistros();
  }, []);

  return (
    <div className="">
      <div
        className="p-2 title-table"
        style={{
          fontFamily: "georgia",
          textAlign: "center",
          fontSize: "30px",
          fontWeight: "bold",
        }}
      ></div>
      <div className="container col-md-11 col-12 amanecergris mx-auto">
        <div className="row py-2 col-md-12">
          <div className="col-md-12 mx-auto">
            <ul
              className="nav nav-tabs"
              id="ex-with-icons"
              role="tablist"
              style={{ borderRadius: "3px 3px 0px 0px" }}
            >
              <li
                className="nav-item"
                onClick={() => setTab(1)}
                role="presentation"
              >
                <a
                  className="nav-link bg-danger estilotab p-2"
                  style={tab === 1 ? estilos.tab : {}}
                  id="ex-with-icons-tab-1"
                  data-mdb-toggle="tab"
                  href="#ex-with-icons-tabs-1"
                  role="tab"
                  aria-controls="ex-with-icons-tabs-1"
                  aria-selected="true"
                >
                  <i className="fas fa-pager fa-fw me-1" />
                  Solicitudes
                </a>
              </li>
            </ul>

            <div
              className="tab-content"
              id="ex-with-icons-content"
              style={tab === 1 ? estilos.contenido : {}}
            >
              <div
                className="tab-pane fade show active"
                id="ex-with-icons-tabs-1"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-1"
              >
                <div className="card text-center">
                  <div className="card-body">
                    <div className="col-md-12 row was-validated">
                      <div className="row col-12 d-flex justify-content-between">
                        <input
                          type="text"
                          className=" col-3 form-control form-control-sm rounded-pill"
                          ref={txtBuscador}
                          onChange={handleSearch}
                          placeholder="Buscar"
                        />
                      </div>
                    </div>
                    <div className="col-md-12 row py-2">
                      {
                        <div className="col-md-12 pt-3">
                          <TblContainer
                            container={{
                              maxHeight: 180,
                              width: "100%",
                              overflow: "auto",
                            }}
                          >
                            <TblHead />
                            <tbody>
                              {records &&
                                recordsAfterPagingAndSorting().map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td className="align-baseline text-center">
                                        {item.txtidsolvencia}
                                      </td>
                                      <td className="align-baseline text-start">
                                        {item.txtnombre}
                                      </td>
                                      <td className="align-baseline text-center">
                                        {moment(item.txtfecha).format(
                                          "DD-MM-YYYY"
                                        )}
                                      </td>
                                      <td className="align-baseline text-end">
                                        {formatMoneda(
                                          item.txtmonto
                                            .toString()
                                            .replace(",", "")
                                            .replace(".", ","),
                                          ",",
                                          ".",
                                          2
                                        )}
                                      </td>
                                      <td className="align-baseline text-center">
                                        {item.txtestatuspago === 1 ? (
                                          <i className="fa fa-check-double text-success">
                                            {" "}
                                            Pagada
                                          </i>
                                        ) : item.txtestatuspago === 2 ? (
                                          <i className="fas text-danger fa-exclamation-triangle">
                                            {" "}
                                            Verificando Pago
                                          </i>
                                        ) : item.txtestatuspago === 0 ? (
                                          <i className="fas text-danger fa-exclamation-triangle">
                                            {" "}
                                            Por Pagar
                                          </i>
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      <td className="align-baseline text-center">
                                        {item.txtestatussolvencia === 0 ? (
                                          <i className="fa fa-exclamation-triangle text-danger">
                                            {" "}
                                            Por Aprobar
                                          </i>
                                        ) : item.txtestatussolvencia === 1 ? (
                                          <i className="fa fa-check-double text-success">
                                            {" "}
                                            Aprobada
                                          </i>
                                        ) : item.txtestatussolvencia === 2 ? (
                                          <i className="fa text-info fa-print">
                                            {" "}
                                            Entregada
                                          </i>
                                        ) : item.txtestatussolvencia === 3 ? (
                                          <i className="fa fa-trash text-warning">
                                            {" "}
                                            Rechazada
                                          </i>
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      <td className="align-baseline text-center">
                                        <button
                                          onClick={imprimirPago(item)}
                                          disabled={
                                            item.txtestatuspago !== 0
                                              ? false
                                              : true
                                          }
                                          className="btn btn-sm  btn-danger rounded-circle ml-2"
                                        >
                                          <i className="fa fa-print"></i>{" "}
                                        </button>
                                        <button
                                          onClick={imprimirSolvencia(item)}
                                          disabled={
                                            item.txtestatussolvencia === 1
                                              ? false
                                              : true
                                          }
                                          className={
                                            accopsolvencia.substring(1, 2) ===
                                            "0"
                                              ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                              : "btn btn-sm mx-1 btn-info rounded-circle"
                                          }
                                        >
                                          <i className="fa fa-print"></i>{" "}
                                        </button>
                                        <button
                                          onClick={gestionarSolicitud(
                                            4,
                                            item.txtidsolvencia
                                          )}
                                          className={
                                            accopsolvencia.substring(3, 4) ===
                                            "0"
                                              ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                              : "btn btn-sm mx-1 btn-info rounded-circle"
                                          }
                                        >
                                          <i className="fa fa-eye"></i>{" "}
                                        </button>
                                        <button
                                          onClick={gestionarSolicitud(
                                            2,
                                            item.txtidsolvencia
                                          )}
                                          disabled={
                                            item.txtestatuspago !== 0
                                              ? false
                                              : true
                                          }
                                          className={
                                            accopsolvencia.substring(2, 3) ===
                                            "0"
                                              ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                              : "btn btn-sm mx-1 btn-success rounded-circle"
                                          }
                                        >
                                          <i className="fa fa-edit"></i>{" "}
                                        </button>
                                        <button
                                          onClick={gestionarSolicitud(
                                            3,
                                            item.txtidsolvencia
                                          )}
                                          disabled={
                                            item.txtestatuspago === 0
                                              ? false
                                              : true
                                          }
                                          className={
                                            accopsolvencia.substring(3, 4) ===
                                            "0"
                                              ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                              : "btn btn-sm mx-1 btn-danger rounded-circle"
                                          }
                                        >
                                          <i className="fa fa-trash"></i>{" "}
                                        </button>
                                      </td>
                                    </tr>
                                  )
                                )}
                            </tbody>
                          </TblContainer>
                          <TblPagination />
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={() =>
          setToast({ mostrar: false, titulo: "", mensaje: "" })
        }
      />
      <SolicitudSolvencia
        show={mostrar}
        solvencia={solvencia}
        operacion={operacion}
        onHide={cerrarModalSolvencia}
      />
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
}

export default Solvencia;



// WEBPACK FOOTER //
// ./src/pages/solicitud_solvencia.js